import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/technician/')({
  beforeLoad: () => {
    console.log("Redirecting from /technician to /technician/dashboard");
    throw redirect({ to: '/technician/dashboard', replace: true });
  }
});
